module.exports = __webpack_public_path__ + "static/media/excelNew.5b119f67.svg";